import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { ActionType } from '../main.action';

export interface SelectUser {
    user?: User;
}

export const selectUser = createAction<ActionType, SelectUser>(
    ActionType.EVAL_MAIN__SELECT_USER,
);
